import * as Types from '../generated/types';

import { gql } from '@apollo/client';
import { PageInfoFragmentDoc } from '../fragments/pageInfo.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DealTreatmentsQueryVariables = Types.Exact<{
  id: Types.Scalars['ID'];
  offset?: Types.InputMaybe<Types.Scalars['Int']>;
  before?: Types.InputMaybe<Types.Scalars['String']>;
  after?: Types.InputMaybe<Types.Scalars['String']>;
  first?: Types.InputMaybe<Types.Scalars['Int']>;
  last?: Types.InputMaybe<Types.Scalars['Int']>;
}>;


export type DealTreatmentsQuery = { __typename?: 'Query', deal?: { __typename?: 'DealNode', treatmentSet: { __typename?: 'TreatmentNodeConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename?: 'TreatmentNodeEdge', node?: { __typename?: 'TreatmentNode', name: string, treatmentTime?: any | null } | null } | null> } } | null };


export const DealTreatmentsDocument = gql`
    query DealTreatments($id: ID!, $offset: Int, $before: String, $after: String, $first: Int, $last: Int) {
  deal(id: $id) {
    treatmentSet(
      offset: $offset
      before: $before
      after: $after
      first: $first
      last: $last
    ) {
      pageInfo {
        ...PageInfo
      }
      edges {
        node {
          name
          treatmentTime
        }
      }
    }
  }
}
    ${PageInfoFragmentDoc}`;

/**
 * __useDealTreatmentsQuery__
 *
 * To run a query within a React component, call `useDealTreatmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDealTreatmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDealTreatmentsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      offset: // value for 'offset'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useDealTreatmentsQuery(baseOptions: Apollo.QueryHookOptions<DealTreatmentsQuery, DealTreatmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DealTreatmentsQuery, DealTreatmentsQueryVariables>(DealTreatmentsDocument, options);
      }
export function useDealTreatmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DealTreatmentsQuery, DealTreatmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DealTreatmentsQuery, DealTreatmentsQueryVariables>(DealTreatmentsDocument, options);
        }
export type DealTreatmentsQueryHookResult = ReturnType<typeof useDealTreatmentsQuery>;
export type DealTreatmentsLazyQueryHookResult = ReturnType<typeof useDealTreatmentsLazyQuery>;
export type DealTreatmentsQueryResult = Apollo.QueryResult<DealTreatmentsQuery, DealTreatmentsQueryVariables>;